import { elementTypeShortLabel } from '@domainConstants'
import type { ResultsViewTab, ResultsViewWallSubTab } from '@editorStores'

/** Short tab text when the list pane is narrower than the full-label breakpoint. */
export const RESULTS2_TAB_SHORT_LABEL: Partial<Record<string, string>> = {
  walls: 'W',
  slabs: elementTypeShortLabel.slabs,
  'roof-slabs': elementTypeShortLabel.roof_slabs,
  beams: elementTypeShortLabel.beams,
  purlins: elementTypeShortLabel.purlins,
  columns: elementTypeShortLabel.columns,
  foundation: elementTypeShortLabel.foundation,
  'wall-rips': elementTypeShortLabel.rips,
  'wall-lintels': elementTypeShortLabel.lintels,
  stiffening: 'W-A',
  anchors: 'ZA',
  'shear-anchors': 'SA',
  'standard-rips': 'ST R',
  'wall-assemblies': 'W',
  'slabs-assemblies': elementTypeShortLabel.slabs,
  'roof-assemblies': elementTypeShortLabel.roof_slabs,
  'slab-beams': 'DE B',
  'roof-beams': 'DA B',
  comments: 'K',
}

export const PRIMARY_TABS: { id: ResultsViewTab; label: string }[] = [
  { id: 'walls', label: 'Wand' },
  { id: 'slabs', label: 'Decke' },
  { id: 'roof-slabs', label: 'Dach' },
  { id: 'beams', label: 'Unterzüge' },
  { id: 'purlins', label: 'Pfetten' },
  { id: 'columns', label: 'Stützen' },
  { id: 'foundation', label: 'Fundament' },
  { id: 'comments', label: 'Kommentare' },
]

export const WALL_SECONDARY_TABS: { id: ResultsViewWallSubTab; label: string }[] = [
  { id: 'wall-rips', label: 'Rippen' },
  { id: 'wall-lintels', label: 'Stürze' },
  { id: 'stiffening', label: 'Scheiben' },
  // The "Anker" tab is only offered while the integrated anchor view is enabled
  // (`results2IntegratedAnchorView` app setting) — see Results2ListPane.
  { id: 'anchors', label: 'Zuganker' },
  { id: 'shear-anchors', label: 'Schubanker' },
  { id: 'standard-rips', label: 'Std-Rippen' },
  { id: 'wall-assemblies', label: 'Wände' },
]

/** @deprecated Use WALL_SECONDARY_TABS */
export const SECONDARY_TABS = WALL_SECONDARY_TABS
